export default {
  patients: {
    label: 'Patienten',
    viewPatients: 'Patienten anzeigen',
    noPatients: 'Es sind noch keine Patienten vorhanden, fügen Sie den Ersten hinzu',
    viewPatient: 'Patient anzeigen',
    editPatient: 'Patient bearbeiten',
    newPatient: 'Neuer Patient',
  },
}
